import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/categories',
    name: 'category',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/category/index.vue')
  },
  {
    path: '/categories/create',
    name: 'category-create',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/category/create.vue')
  },
  {
    path: '/categories/:id',
    name: 'category-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/inventory/category/edit.vue'),
    props: route => ({ editData: route.params.editData })
  }
]
